import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck, Clock, Award, Users } from 'lucide-react';
import { getContent } from '../utils/contentStore';
import { useLanguage } from '../utils/i18n';
import { renderIcon } from '../utils/iconMap';
export function WhyUs() {
  const team = getContent().teamMembers;
  const content = getContent().about;
  const {
    t,
    loc
  } = useLanguage();
  // Check if features have any content
  const hasFeatures = content.features.some(f => loc(f.title).trim() !== '' || loc(f.text).trim() !== '');
  return <Section id="about" dark className="relative overflow-hidden" data-id="element-389">
      {/* Subtle background glow */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-390">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-391" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-392" />
      </div>

      <div className="relative z-10 mb-20" data-id="element-393">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-394">
          <div data-id="element-395">
            <h2 className="text-gray-400 font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-396">
              {loc(content.label)}
            </h2>
            <h3 className="font-heading text-4xl md:text-5xl font-bold text-white uppercase mb-6 leading-tight" data-id="element-397">
              {loc(content.title1)} <br data-id="element-398" />
              <span className="text-red-500" data-id="element-399">{loc(content.title2)}</span>
            </h3>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-400">
              {loc(content.description)}
            </p>

            {hasFeatures && <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-401">
                {content.features.map((item, i) => <div key={i} className="flex gap-4" data-id="element-402">
                    <div className="bg-white/10 p-3 h-fit rounded text-gray-300" data-id="element-403">
                      {renderIcon(item.icon, 'h-6 w-6')}
                    </div>
                    <div data-id="element-404">
                      <h4 className="font-heading text-xl font-bold text-white mb-2" data-id="element-405">
                        {loc(item.title)}
                      </h4>
                      <p className="text-gray-400 text-sm" data-id="element-406">{loc(item.text)}</p>
                    </div>
                  </div>)}
              </div>}
          </div>

          <div className="relative" data-id="element-407">
            <div className="absolute inset-0 border-2 border-white/20 translate-x-4 translate-y-4 rounded-sm" data-id="element-408" />
            <img src={content.image} alt="Laboratory" className="relative rounded-sm shadow-2xl w-full h-auto grayscale hover:grayscale-0 transition-all duration-500" data-id="element-409" />
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="relative z-10" data-id="element-410">
        <div className="text-center mb-12" data-id="element-411">
          <h3 className="font-heading text-3xl font-bold text-white uppercase mb-2" data-id="element-412">
            {loc(content.teamTitle1)}{' '}
            <span className="text-red-500" data-id="element-413">{loc(content.teamTitle2)}</span>
          </h3>
          <p className="text-gray-400" data-id="element-414">{loc(content.teamDesc)}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-415">
          {team.map((member, index) => <div key={index} className="group bg-white/5 backdrop-blur-sm p-6 rounded-sm border border-white/10 hover:border-white/25 transition-all duration-300" data-id="element-416">
              <div className="aspect-square overflow-hidden rounded-sm mb-6 bg-gray-800" data-id="element-417">
                <img src={member.image} alt={loc(member.name)} className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-418" />
              </div>
              <h4 className="font-heading text-xl font-bold text-white mb-2" data-id="element-419">
                {loc(member.name)}
              </h4>
              <p className="text-gray-400 text-sm font-medium" data-id="element-420">
                {loc(member.role)}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}